import { transformDateTypeEnglishWithSpace } from '@/helpers/functions/convertDate'
import { HTTP_HYPER_ESPACE_BACKEND } from '@/services/http-common'
import moment from 'moment'
import { buildUriForCall } from '@/helpers/functions/buildUri'

export default {
  namespaced: true,
  state: {
    listEvents: [],
    listEventsByAnnonce: [],
    isLoading: false,
    filters: {
      network: null,
      typePost: null,
      startDate: null,
      endDate: null,
      search: null
    },
    postsCount: {
      ads: 0,
      bv: 0,
      edito: 0
    }
  },
  getters: {
    getListEvents: (state) => state.listEvents,
    getListEventsByAnnonceByNetwork: (state) => (network) => {
      return state.listEventsByAnnonce.filter((items) => {
        if (network === 'GoogleMyBusiness') {
          network = network.match(/[A-Z][a-z]+/g)[0]
        }
        if (network === 'CreationBV' || network === null) {
          return null
        }
        return items.portails.some((element) => element.code.split('_')[0] === network.toUpperCase())
      })
    },
    getIsLoadingStatus: (state) => state.isLoading,
    getFilters: (state) => state.filters,
    getDataAds: (state) => {
      return state.listEvents.filter((event) => {
        const portail = event.portails[0].code
        return !portail.endsWith('_EDITO') && event.etat !== 'V'
      })
    },
    getDataBv: (state) => state.listEvents.filter((event) => event.etat === 'V'),
    getDataEdito: (state) => {
      return state.listEvents.filter((event) => {
        const portail = event.portails[0].code
        return portail.endsWith('_EDITO')
      })
    },
    getPostCountAds: (state) => state.postsCount.ads,
    getPostCountBv: (state) => state.postsCount.bv,
    getPostCountEdito: (state) => state.postsCount.edito
  },
  mutations: {
    fetchListEvents (state, payload) {
      state.listEvents = payload
    },
    addListEvents (state, payload) {
      state.listEvents.push(payload)
      state.listEventsByAnnonce.push(payload)
    },
    deleteListEvents (state, id) {
      state.listEvents = state.listEvents.filter((event) => event.id !== id)
      state.listEventsByAnnonce = state.listEventsByAnnonce.filter((event) => event.id !== id)
    },
    updateListEvents (state, payload) {
      const index = state.listEvents.findIndex((event) => event.id === payload.id && event.portails[0].code === payload.portails[0].code)
      if (index > -1) {
        state.listEvents[index].scheduled = payload.scheduled
      }
    },
    fetchListEventsByAnnonce (state, payload) {
      state.listEventsByAnnonce = payload
    },
    setIsLoading (state, bool) {
      state.isLoading = bool
    },
    setFilters (state, { key, value }) {
      state.filters = {
        ...state.filters,
        [key]: value
      }
    },
    resetFilters (state) {
      state.filters.network = null
      state.filters.typePost = null
      state.filters.startDate = null
      state.filters.endDate = null
      state.filters.search = null
    },
    setPostCountAds (state, nb) {
      state.postsCount.ads = nb
    },
    setPostCountBv (state, nb) {
      state.postsCount.bv = nb
    },
    setPostCountEdito (state, nb) {
      state.postsCount.edito = nb
    }
  },
  actions: {
    loadEvents ({ state, commit }) {
      commit('setIsLoading', true)

      const path = '/events_calendar'
      const uri = buildUriForCall(path, state.filters)

      HTTP_HYPER_ESPACE_BACKEND.get(uri)
        .then(response => {
          commit('setIsLoading', false)
          // Change format start date
          const events = response.data
          events.forEach((event) => {
            event.start = moment(event.start).format('YYYY-MM-DD HH:mm')
          })
          commit('fetchListEvents', events)
        }).catch(error => {
          console.log({ type: 'error', message: error })
        }).finally(() => {
          commit('setIsLoading', false)
        })
    },
    loadEventsByAnnonce (context, id) {
      const postsByAnnonce = context.state.listEvents.filter((event) => event.annonces[0] == id)
      context.commit('fetchListEventsByAnnonce', postsByAnnonce)
    },
    loadEventsForOneDayByTypePost ({ state, commit }, { date }) {
      commit('setIsLoading', true)
      const targetStart = new Date(date)
      targetStart.setHours(0, 0, 0, 0)
      const targetEnd = new Date(date)
      targetEnd.setHours(23, 59, 59, 999)
      const filteredEvents = state.listEvents.filter(event => {
        const eventDate = new Date(event.start)
        return eventDate >= targetStart && eventDate <= targetEnd
      })
      commit('fetchListEvents', filteredEvents)
      commit('setIsLoading', false)
    },
    createEventNow (context, payload) {
      const { payloadPlanif, newEvent } = payload
      HTTP_HYPER_ESPACE_BACKEND
        .post('/socialposts', payloadPlanif)
        .then((response) => {
          if (response.status === 200) {
            const newPost = { ...response.data.data, ...newEvent }
            newPost.status = newPost.scheduled.lastExecution !== null ? 'postPublished' : 'postPlanned'
            context.commit('addListEvents', newPost)
          }
        }).catch((error) => {
          console.log({ type: 'error', message: error })
        })
    },
    deleteScheduled (context, payload) {
      const idPlanification = payload[0].id
      const idAnnonce = payload[0].annonces[0]

      HTTP_HYPER_ESPACE_BACKEND.delete(`/eventCalendar/${idPlanification}/${idAnnonce}`)
        .then((response) => {
          if (response.data[0] === 'ok') {
            context.commit('deleteListEvents', idPlanification)
          }
        }).catch((error) => {
          console.log(error)
        })
    },
    deletedAllSchedules (context, payload) {
      const planifications = payload
      if (planifications.length > 0) {
        for (const planification of planifications) {
          HTTP_HYPER_ESPACE_BACKEND.delete(`/eventCalendar/${planification.id}/${planification.annonces[0]}`)
            .then((response) => {
              if (response.data[0] === 'ok') {
                context.commit('deleteListEvents', planification.id)
              }
            }).catch((error) => {
              console.log(error)
            })
        }
      }
    },
    updateCronExpressionEvent (context, payload) {
      const [post, time, date] = payload
      const newDate = new Date(`${date}T${time}`)
      const cronExpression = `${newDate.getMinutes()} ${newDate.getUTCHours()} ${newDate.getUTCDate()} ${newDate.getUTCMonth() + 1} *`
      const indexOldPost = context.state.listEvents.findIndex((event) => event.id === post.id)
      const changedOldPost = context.state.listEvents[indexOldPost]
      changedOldPost.scheduled.cronExpression = cronExpression
      changedOldPost.start = transformDateTypeEnglishWithSpace(newDate)
      const newPost = {
        id: post.id,
        annonces: [post.annonces[0]],
        scheduled: {
          cronExpression: cronExpression,
          lastExecution: null,
          status: '1',
          cronDate: null
        }
      }

      HTTP_HYPER_ESPACE_BACKEND
        .put('/socialposts', newPost)
        .then((response) => {
          if (response.status === 200) {
            const postUpdated = response.data.data
            for (const property in changedOldPost) {
              if (!postUpdated[property]) {
                postUpdated[property] = changedOldPost[property]
              }
            }
            context.commit('updateListEvents', postUpdated)
          }
        }).catch((error) => {
          console.log({ type: 'error', message: error })
        })
    }
  }
}
